import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import './ManageBranches.css';

import { isLoggedIn, selectToken } from '../login/loginSlice';
import { branchesLoading, loadAllBranches, loadBranches, selectBranches } from './branchesSlice';
import { selectCreatedBranch, toggleCreateBranchForm } from '../createBranchForm/createBranchFormSlice';
import { changeEditBranchId, changeEditBranchName, toggleEditBranchForm } from '../editBranchForm/editBranchFormSlice';

import Sidebar from '../../components/sidebar/Sidebar';
import CreateBranchForm from '../createBranchForm/CreateBranchForm';
import EditBranchForm from '../editBranchForm/EditBranchForm';
import { selectUser } from '../home/userSlice';
import { changeSearchMode, changeSearchTarget, changeSearchTargetOptions, selectFilters, selectSearchMode } from '../searchBar/searchBarSlice';
import SearchBar from '../searchBar/SearchBar';
import Filter from '../../components/filter/Filter';

export default function ManageBranches() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const token = useSelector(selectToken);

    const loggedIn = useSelector(isLoggedIn);
    const branches = useSelector(selectBranches);
    const loadingBranches = useSelector(branchesLoading);
    const createdBranch = useSelector(selectCreatedBranch);

    const userInfo = useSelector(selectUser);
    const userRole = userInfo.userRole;
    const bankId = userInfo.bankId;

    const searchMode = useSelector(selectSearchMode);
    const searchFilters = useSelector(selectFilters);
    const branchFilters = searchFilters.filter(filter => filter.searchMode === 'branch');

    const filteredBranches = branchFilters.length < 1 ? branches : branches.filter(branch => {
        let filterCheck = true;

        branchFilters.forEach(filter => {
            if (filter.active && filterCheck) {
                if (filter.searchTarget === 'Branch Id') {
                    filterCheck = branch.branchId.includes(filter.searchTerm);
                } else if (filter.searchTarget === 'Branch Name') {
                    filterCheck = branch.branchName.includes(filter.searchTerm);
                }
            }
        })
        return filterCheck;
    })

    useEffect(() => {
        if (!loggedIn) {
            navigate('../login');
        }
    }, [navigate, loggedIn])

    useEffect(() => {
        if (userRole === 'ADMIN') {
            dispatch(loadBranches({bankId, token}));
        } else if (userRole === 'SUPERADMIN') {
            dispatch(loadAllBranches(token));
        }
    }, [dispatch, userRole, bankId, createdBranch, token])

    useEffect(() => {
        if (searchMode !== 'branch') {
            dispatch(changeSearchMode('branch'));
            dispatch(changeSearchTargetOptions(['Branch Id', 'Branch Name']));
            dispatch(changeSearchTarget('Branch Name'));
        }
    })

    const handleCreateBranchButtonClick = () => {
        dispatch(toggleCreateBranchForm());
    }

    const handleEditBranchButtonClick = (event) => {
        const editBranchId = event.target.value;
        const branchToEdit = branches.find(branch => branch.branchId === editBranchId);
        dispatch(changeEditBranchId(branchToEdit.branchId));
        dispatch(changeEditBranchName(branchToEdit.branchName));
        dispatch(toggleEditBranchForm());
    }

    return (
        <main>
            <Sidebar />
            <section className='manage-branches'>
                <div>
                    <h2>Manage Branches</h2>
                    
                </div>
                <div className='branch-header'>
                    <SearchBar />
                    <button onClick={handleCreateBranchButtonClick}>Create Branch</button>
                </div>
                <div className='filters'>
                    {branchFilters.map(filter => <Filter filter={filter}/>)}
                </div>
                {loadingBranches ? <h3>Loading Branches...</h3> : <table>
                    <thead>
                        <tr>
                            <th>Edit</th>
                            <th>Branch Id</th>
                            <th>Branch Name</th>
                            <th>Number of Accounts</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredBranches.map((branch) => {
                            return (
                                <tr key={branch.branchId}>
                                    <td><button onClick={handleEditBranchButtonClick} value={branch.branchId}>Edit</button></td>
                                    <td>{branch.branchId}</td>
                                    <td>{branch.branchName}</td>
                                    <td>{branch.numOfAccounts}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>}
            </section>
            <CreateBranchForm />
            <EditBranchForm />
        </main>
    )
}